import React from 'react';

import { margin } from '@lumapps/classnames';
import { mdiCheckDecagram } from '@lumapps/lumx/icons';
import { ColorPalette, ColorVariant, Icon, Size, Text, Typography } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { ASK_AI } from '../../keys';

/**
 * Component displaying an indication to the user in case an answer is based on an ask ai rule
 * @returns AskAiHumanCuratedDisclaimer
 */
export const AskAiHumanCuratedDisclaimer = () => {
    const { translateKey } = useTranslate();
    return (
        <Text as="p" typography={Typography.caption} color={ColorPalette.dark} colorVariant={ColorVariant.L1}>
            <Icon icon={mdiCheckDecagram} size={Size.xxs} className={margin('right', 'regular')} />
            {translateKey(ASK_AI.RULE_BASED_RESULT)}
        </Text>
    );
};
